import * as React from 'react';
import { Box, Card, Typography } from '@mui/material';
import { FaOptionIcon, NamedIconsType } from '@europrocurement/l2d-icons';

export type ListingTitleProps = {
    title: string;
    modelIcon: NamedIconsType;
};

export const ListingTitle: React.FunctionComponent<ListingTitleProps> = function ({
    title,
    modelIcon,
}) {
    return (
        <Card sx={{ width: '84%', margin: '0 0 15px 0', maxHeight: '60px', padding: 2 }}>
            <Box
                display="flex"
                alignItems="center"
                sx={{ columnGap: '20px' }}
            >
                <Box>
                    <FaOptionIcon
                        {...modelIcon.props}
                        size="xl"
                    />
                </Box>
                <Typography fontSize="20px">{title}</Typography>
            </Box>
        </Card>
    );
};
